import {
  AccordionDetails,
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  Link,
  Radio,
  RadioGroup,
  Stack
} from '@mui/material';
import React from 'react';
import { useDispatch } from 'react-redux';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useUser } from 'src/components/hooks/useUser';
import { sendRequest } from 'src/hooks/useFetch';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
// import { setSnackbarMessage } from 'src/store/snackbarMessage';
import { clearMessage, setMessage } from 'src/store/Message';
import { ISIVChecklistMonitoring } from 'src/types/SIVChecklist';
import { formatInput } from 'src/util/STR';
import { useFieldTranslation } from '../../fields/useFieldTranslation';
import {
  IMonitoringMandatory,
  ISIVChecklistMandatory,
  ISIVChecklistModifiedKeys,
  ISIVChecklistModifiedKeysOfKeys,
  MandatoryData
} from './useSivChecklist';
import { setIsSaveButtonDisable } from 'src/store/sivCheckList';

export interface IMonitoring {
  getSivChecklistData: (key: ISIVChecklistModifiedKeysOfKeys, add: boolean) => void;
  saveDisable: boolean;
  updateMonitoring: (data: ISIVChecklistMonitoring) => void;
  monitoringData: ISIVChecklistMonitoring;
  isUpdate: boolean;
  isChange: boolean;
  setIsChange: (step: ISIVChecklistModifiedKeys, key: ISIVChecklistModifiedKeysOfKeys, val: boolean) => void;
  updateSIVChecklistMandatoryData: (key: keyof ISIVChecklistMandatory, value: MandatoryData) => void;
  mandatory: IMonitoringMandatory;
  validatemonitoring: any;
  checkedInStartDate: any;
  isPublished: boolean;
  SignatureBreaking: () => void;
}

const Monitoring: React.FunctionComponent<IMonitoring> = ({
  getSivChecklistData,
  saveDisable,
  monitoringData,
  updateMonitoring,
  isUpdate,
  setIsChange,
  isChange,
  mandatory,
  updateSIVChecklistMandatoryData,
  validatemonitoring,
  checkedInStartDate,
  isPublished,
  SignatureBreaking
}) => {
  // const [monitoringData, setMonitoringData] = useState<any>({
  //   siv_checklist_monitoring_plan: sivChecklistData.siv_checklist_monitoring_plan,
  //   siv_checklist_monitoring_plan_comm: sivChecklistData.siv_checklist_monitoring_plan_comm || ''
  // });
  //const [isChange, setIsChange] = useState(false);
  //const [isUpdate, setIsUpdate] = useState(sivChecklistData.study_id ? true : false);
  const dispatch = useDispatch();
  const dispatchApp = useAppDispatch();
  const user = useUser();

  const { sivcDataUpdateSuccessMsg, sivcMendatoryInfoErrorMsg } = useFieldTranslation();
  // const [validate, setValidate] = useState({
  //   siv_checklist_monitoring_plan: false
  // } as any);

  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const { checkPermission } = usePermissionWrapper();
  const isDisable = checkPermission('update_siv_checklist');
  const selectedRowData: any = useAppSelector(state => state.sivCheckList.selectedRowData);
  const saveButtonDisable: any = useAppSelector(state => state.sivCheckList.disableSaveButtonProps);

  const handleMonitoringData = (e: any) => {
    const val = e.target.value;
    const formattedVal = typeof val === 'string' ? formatInput(val) : val;
    const value = formattedVal;
    dispatchApp(clearMessage());
    if (e.target.type === 'radio' && value === 'Y') {
      updateMonitoring({ ...monitoringData, [e.target.name]: value, [`${e.target.name}_comm`]: '' });
      //setValidate({ ...validate, [e.target.name]: false });
      updateSIVChecklistMandatoryData('monitoring', { ...mandatory, [e.target.name]: false });
    } else {
      updateMonitoring({ ...monitoringData, [e.target.name]: value });
    }
    const validateKey = `${e.target.name.replace('_comm', '')}`;
    if (e.target.name?.indexOf('_comm') !== -1) {
      if (!(value && value !== null && value !== '')) {
        //setValidate({ ...validate, [validateKey]: true });
        updateSIVChecklistMandatoryData('monitoring', { ...mandatory, [validateKey]: true });
      } else {
        //setValidate({ ...validate, [validateKey]: false });
        updateSIVChecklistMandatoryData('monitoring', { ...mandatory, [validateKey]: false });
      }
    }
    dispatch(setIsSaveButtonDisable({ ...saveButtonDisable, monitoring: false }));
    setConfirmExitValue(dispatch, true);
    //setIsChange(true);
    //setIsChanged(true);
  };

  const updateMonitoringData = async () => {
    const options = {
      site_id: selectedSite,
      study_id: studyId,
      data: {
        updated_by: user.user,
        monitoring_visit_id: selectedRowData.id,
        siv_checklist: { step_two: { monitoring: monitoringData } }
      },
      pathVariables: {
        country: selectedCountry,
        appName: process.env.REACT_APP_NAME
      }
    };
    try {
      if (isChange) {
        if (isUpdate) {
          if (monitoringData.siv_checklist_monitoring_plan !== null) {
            await sendRequest('update_sivChecklist_data', options);
            if (isPublished) {
              SignatureBreaking();
            }
            getSivChecklistData('monitoring', false);
            setConfirmExitValue(dispatch, false);
            // setIsChange(false);
            // setIsChanged(false);
            setIsChange('Step2', 'monitoring', false);
            // store.dispatch(setSnackbarMessage('Monitoring data is successfully saved', 'success'));
            dispatchApp(setMessage({ msgDetails: sivcDataUpdateSuccessMsg, severity: 'success' }));
          } else {
            // store.dispatch(setSnackbarMessage('Mandatory information is missing. Information cannot be saved', 'error'));
            dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
          }
        }
        if (!isUpdate) {
          if (monitoringData.siv_checklist_monitoring_plan !== null) {
            await sendRequest('create_sivChecklist_data', options);
            getSivChecklistData('monitoring', true);
            //setIsUpdate(true);
            setConfirmExitValue(dispatch, false);
            //setIsChange(false);
            //setIsChanged(false);
            setIsChange('Step2', 'monitoring', false);
            // store.dispatch(setSnackbarMessage('Monitoring data is successfully saved', 'success'));
            dispatchApp(setMessage({ msgDetails: sivcDataUpdateSuccessMsg, severity: 'success' }));
          } else {
            // store.dispatch(setSnackbarMessage('Mandatory information is missing. Information cannot be saved', 'error'));
            dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
          }
        }
      } else if (!isChange && monitoringData.siv_checklist_monitoring_plan === null) {
        // store.dispatch(setSnackbarMessage('Mandatory information is missing. Information cannot be saved', 'error'));
        dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
      } else if (validatemonitoring) {
        dispatchApp(setMessage({ msgDetails: 'No data modified', severity: 'info' }));
      } else {
        dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
      }
      dispatch(setIsSaveButtonDisable({ ...saveButtonDisable, monitoring: true }));
    } catch (e) {
      // store.dispatch(setSnackbarMessage('Mandatory information is missing. Information cannot be saved', 'error'));
      dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
    }
  };

  return (
    <>
      <AccordionDetails className="sq-checklist-tab">
        <Grid container className="checklist-radio-actions">
          <Grid md={12}>
            <Grid container>
              <Grid md={9}>
                Monitoring details and general plan provided to the site.{' '}
                <Link underline="always">(Link to site monitoring plan)</Link> <span style={{ color: 'red' }}>*</span>
              </Grid>
              <Grid md={3}>
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="siv_checklist_monitoring_plan"
                    value={monitoringData.siv_checklist_monitoring_plan}
                    onChange={handleMonitoringData}
                  >
                    <FormControlLabel
                      disabled={!isDisable || saveDisable || !checkedInStartDate}
                      value="Y"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      disabled={!isDisable || saveDisable || !checkedInStartDate}
                      value="N"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </AccordionDetails>
      <Grid container className="fixed-buttons-block">
        <Grid md={12} display="flex" justifyContent="flex-end">
          <Stack spacing={2} direction="row">
            {isDisable ? (
              <Button
                onClick={updateMonitoringData}
                disabled={saveButtonDisable.monitoring || !checkedInStartDate}
                variant="text"
              >
                SAVE
              </Button>
            ) : (
              ''
            )}
          </Stack>
        </Grid>
      </Grid>
    </>
  );
};

export default Monitoring;
